module.exports = __webpack_public_path__ + "img/ymc-thumb3.ab51001f.png";